import React from "react"
import { useTranslation } from "react-i18next"
import Typography from "@mui/material/Typography"
import { useDispatch } from "react-redux"
import { useHistory, useParams } from "react-router-dom"
import {useSnackbar} from "notistack"

// @ts-ignore
import Container from "../../../../components/Container"
import CreateChangeOrderForm from "../../../../forms/CreateChangeOrder"
import { CreateChangeOrderInitialValues } from "../../../../forms/CreateChangeOrder.types"
import { convertFormValuesToApiData } from "../../../../forms/CreateChangeOrder.submit"
import {createChangeOrder, uploadChangeOrderFiles} from "../../../../api/changeOrder"
import { addChangeOrder } from "../../../../store/features/changeOrdersSlice"
import { useTracFloSelector } from "../../../../store/useTracFloSelector"
import {goToSingleChangeOrder} from "../../../../util/routes"

export default function CreateChangeOrder() {
  const dispatch = useDispatch()
  const { t } = useTranslation("private")
  const history = useHistory()
  const { projectId } = useParams<{projectId: string}>()
  const project = useTracFloSelector((state) => state.project)
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const submitChangeOrder = async (
    values: CreateChangeOrderInitialValues,
    nextChangeOrderNumber: string|null,
    addedTickets: any[]
  ) => {
    try {
      const { data: newChangeOrder } = await createChangeOrder(
        projectId,
        convertFormValuesToApiData(values, nextChangeOrderNumber, addedTickets)
      )
      if (newChangeOrder?.id) {
        enqueueSnackbar("Change Order Created", {
          variant: "success",
        })
        dispatch(addChangeOrder(newChangeOrder))
        // need to check that files actually exist
        if (values.files.length > 0 && !!values.files[0].name) {
          const uploadingKey = enqueueSnackbar('Uploading files...', {variant: 'info'})
          const fileUploadMessage = await uploadChangeOrderFiles(values.files, project.id, newChangeOrder.id)
          closeSnackbar(uploadingKey)
          enqueueSnackbar(
            fileUploadMessage.message,
            {
              variant: fileUploadMessage.error ? 'error' : 'success',
              style: {whiteSpace: 'pre-wrap'}
            }
          )
        }
        history.push(goToSingleChangeOrder(project.id, newChangeOrder.id))
      } else {
        enqueueSnackbar("There was a problem creating the change order.", {
          variant: "error",
        })
      }
    } catch(_) {
      enqueueSnackbar("There was a problem creating the change order.", {
        variant: "error",
      })
    }
  }

  return project && project.id === projectId ? (
    <>
      <Container>
        <Typography variant="h1">{t("view.ChangeOrder.add")}</Typography>
      </Container>

      <CreateChangeOrderForm
        submitValues={submitChangeOrder}
        projectId={project.id}
      />
    </>
  ) : (
    <></>
  )
}
